import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.1341 6.99603C10.2688 6.99655 10.402 7.02427 10.5257 7.07754C10.6495 7.13081 10.7611 7.20853 10.8541 7.30603L14.7141 11.306C14.8973 11.493 14.9999 11.7443 14.9999 12.006C14.9999 12.2678 14.8973 12.5191 14.7141 12.706L10.7141 16.706C10.6209 16.7993 10.5102 16.8732 10.3883 16.9237C10.2665 16.9742 10.136 17.0001 10.0041 17.0001C9.87223 17.0001 9.74166 16.9742 9.61984 16.9237C9.49802 16.8732 9.38733 16.7993 9.29409 16.706C9.20085 16.6128 9.12689 16.5021 9.07643 16.3803C9.02597 16.2585 9 16.1279 9 15.996C9 15.8642 9.02597 15.7336 9.07643 15.6118C9.12689 15.49 9.20085 15.3793 9.29409 15.286L12.5941 11.996L9.41409 8.69603C9.22784 8.50867 9.1233 8.25522 9.1233 7.99103C9.1233 7.72685 9.22784 7.4734 9.41409 7.28603C9.50872 7.19215 9.62116 7.11813 9.74481 7.06833C9.86845 7.01852 10.0008 6.99394 10.1341 6.99603Z",
		fill: "currentColor"
	})
});
export default SvgIconChevronRight;
